import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ListDisplayService } from '../list-display.service';
import { NvMatTooltipModule } from './../../../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ListSummaryGroupings } from './../../../../shared/services/list-summary-groupings/list-summary-groupings.service';
import { ListDisplayModule } from './../list-display.module';
import { ListDisplayStudents } from './list-display-students.component';

@NgModule({
  declarations: [ListDisplayStudents],
  imports: [ListDisplayModule, CommonModule, NvMatTooltipModule, MatButtonModule],
  exports: [ListDisplayStudents],
  providers: [ListDisplayService, ListSummaryGroupings],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ListDisplayStudentModule {
  /** */
}
